export const dayFilterOptions = [
    {
        id: 1,
        title: 'Today',
    },
    {
        id: 2,
        title: 'Tomorrow',
    },
    {
        id: 3,
        title: 'Yesterday',
    },
];
export const primaryColor = localStorage.getItem('--theme-default') || '#7366FF';
export const secondaryColor = localStorage.getItem('--theme-secondary') || '#838383';
export const successColor = localStorage.getItem('success') || '#65c15c';
export function initInputField() {
    return {
        data: '',
        errorMessage: '',
    };
}
export function initSelectField() {
    return {
        selected: null,
        data: '',
        selectedItems: [],
        errorMessage: '',
        type: 'dropdown',
    };
}
export function initCheckboxField() {
    return {
        data: false,
        errorMessage: '',
        type: 'checkbox',
    };
}
